export default "__VITE_ASSET__0c9d7848__"